<div class="note-action-wrapper">
    <!-- Note Action -->
    <div class="note-action">
        <label for="">Add Note</label>
        <div class="note-action__boxes">
            <textarea rows="18" [(ngModel)]="campaignService.notes"  placeholder="Add Note"></textarea>
        </div>
        <!-- <div class="note-action__btn">
            <div><span>Cancel</span></div>
            <div class="bg--secondary"><span>Save</span></div>
        </div> -->
    </div>
</div>